import api from './api';
import { ApiResponse } from '../types/api';
import type { StudentQuizScore } from '../types/quizResult';

function getErrorMessage(body: ApiResponse<unknown>, fallback: string): string {
  if (typeof body.message === 'string' && body.message) return body.message;
  if (typeof body.data === 'string' && body.data) return body.data;
  return fallback;
}

function normalizeQuizScore(raw: Record<string, unknown>): StudentQuizScore {
  return {
    quizId: Number(raw.quizId ?? raw.QuizId ?? 0),
    quizName: String(raw.quizName ?? raw.QuizName ?? ''),
    score: Number(raw.score ?? raw.Score ?? 0),
    fullMark: Number(raw.fullMark ?? raw.FullMark ?? 0),
    submittedAt: (raw.submittedAt ?? raw.SubmittedAt ?? null) as string | null,
  };
}

function unwrapQuizList(body: ApiResponse<unknown>): StudentQuizScore[] | null {
  if (!body.success) return null;

  const candidates = [body.data, body.message];
  for (const candidate of candidates) {
    if (Array.isArray(candidate)) {
      return candidate.map((item) => normalizeQuizScore(item as Record<string, unknown>));
    }
  }

  return null;
}

export const quizResultService = {
  async getStudentQuizzes() {
    try {
      const response = await api.get<ApiResponse<unknown>>('/api/quizresult/student-quizzes');
      const body = response.data;
      const quizzes = unwrapQuizList(body);

      if (!quizzes) {
        return { success: false as const, error: getErrorMessage(body, 'تعذر تحميل درجات الاختبارات') };
      }

      return { success: true as const, data: quizzes };
    } catch (error: unknown) {
      const err = error as { response?: { data?: ApiResponse<unknown> } };
      const message = err.response?.data
        ? getErrorMessage(err.response.data, 'تعذر تحميل درجات الاختبارات')
        : 'تعذر تحميل درجات الاختبارات';
      return { success: false as const, error: message };
    }
  },
};
